/** Share Certificate 문서 provide/inject 컨텍스트. */
import type { InjectionKey, Ref } from 'vue';
import type { ShareCertFieldType } from './shareCertFields';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

export interface ShareCertDocContext {
  valueOf: (key: string) => string;
  labelOf: (key: string) => string;
  typeOf: (key: string) => ShareCertFieldType;
  activeKey: Ref<string>;
  activate: (key: string) => void;
  setFieldValue: (key: string, val: string) => void;
  openAddress: (key: string) => void;
  entityCd: Ref<string>;
  signersOf: (varKey: string) => SignerEntry[];
  setSigners: (varKey: string, list: SignerEntry[]) => void;
  pendingPickValue: Ref<string>;
  placePick: (key: string) => boolean;
  certOptions: () => Array<{ title: string; value: string; shares: number }>;
  selectCertNo: (certNo: string) => void;
}

export const SHARE_CERT_DOC_CTX: InjectionKey<ShareCertDocContext> = Symbol('shareCertDocCtx');
